import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import type { Extensions } from "@tiptap/core";
import { BlipToken } from "./token-node";
import { FontSize } from "./font-size";

export interface PresetOptions {
  /** 이미지 익스텐션 포함 여부(기본 true). src=CDN URL 인라인만, base64 비허용. */
  image?: boolean;
  /** blipToken 노드 포함 여부(기본 true). 펀딩 안내/가이드 등 `{@키}` 치환 본문용. */
  tokens?: boolean;
  /** 글자 크기 마크 포함 여부(기본 true). `<span style="font-size">` 렌더/파싱. */
  fontSize?: boolean;
}

/**
 * 프레임워크 무관 익스텐션 프리셋.
 * StarterKit(v3): doc/paragraph/text/bold/italic/strike/heading/list/link/code/blockquote 등.
 * 모든 표면(vue2/vue3/react)이 동일 프리셋 공유 → 출력 HTML·직렬화 일관성.
 */
export function buildExtensions(opts: PresetOptions = {}): Extensions {
  const extensions: Extensions = [StarterKit];
  if (opts.image !== false) {
    extensions.push(Image.configure({ inline: false, allowBase64: false }));
  }
  if (opts.tokens !== false) {
    extensions.push(BlipToken);
  }
  if (opts.fontSize !== false) {
    extensions.push(FontSize);
  }
  return extensions;
}
